import ErrorState from "./error";
import CurrencyState from "./currency";
import EventLog from "../../logger/events";
import { bindActionCreators } from "redux";
import { $processing } from "../payment/helpers/charge";
import { $successful, PAYMENT_METHODS } from "../payment";
import { SWITCH_PAYMENT_METHOD } from "../helpers/actions";
import { isFunction, isPlainObject, withProperties, getValueAtPath } from "../../utils";
import { SWITCH_METHOD_EVENT } from "../helpers/tokens";
import CampaignState from "./campaign";

export default function state() {
  const NAME = 'method';
  const $state = Object.create(null);
  const { data, dispatch } = this;

  const initialPaymentMethod = getValueAtPath(data, 'initial_method');

  const STATE = {
    current: initialPaymentMethod,
    initial: initialPaymentMethod,
    label: getValueAtPath(PAYMENT_METHODS, `${initialPaymentMethod}[name]`) || null
  };

  let previousCurrency;
  let isFirstPaymentMethod = true;

  // Augment $state with properties
  withProperties($state, {
    NAME,
    Reducer,
    actions: withProperties(Object.create(null), { switchMethod }),
    exposedActions: withProperties(Object.create(null), {
      PaymentMethod: bindActionCreators({ switch: switchMethod }, dispatch)
    })
  });

  function Reducer(state = STATE, action) {
    const payload = isPlainObject(action.payload) ? action.payload : {};

    switch (action.type) {
      case SWITCH_PAYMENT_METHOD: {
        const { method } = payload;
        const { current } = state;

        if (method !== current) {
          return {
            ...state,
            current: method,
            label: getValueAtPath(PAYMENT_METHODS, `${method}[name]`) || null
          }
        }

        return state;
      }

      default: return state;
    }
  }

  function switchMethod(method) {
    return (dispatch) => {
      const { current } = $state.STATE;
      const { methods, current: currentCurrency } = CurrencyState.STATE;

      if ($successful !== true && $processing !== true && methods.indexOf(method) >= 0) {
        let performMountOperation = !(
          method === current &&
          previousCurrency &&
          previousCurrency === currentCurrency
        );

        if (performMountOperation) {
          performMountOperation = function _mountOperation(operation) {
            let op = getValueAtPath(PAYMENT_METHODS, operation);
            isFunction(op) && isFunction(op = op()) && dispatch(op);
          }
        }

        performMountOperation && performMountOperation(`${current}[unmount]`);
        method !== current ? (
          dispatchEvent(new CustomEvent(SWITCH_METHOD_EVENT, {
            bubbles: false,
            cancelable: false,
            detail: {
              current: method,
              previous: current
            }
          })),
          dispatch({ type: SWITCH_PAYMENT_METHOD, payload: { method } }),
          // Ensure that any error message is cleared when you switch payment method
          dispatch(ErrorState.actions.updateErrorMessage()),
          dispatch(CampaignState.actions.updateCampaign({})),

          EventLog.switchedMethod($state.STATE.label || $state.STATE.current)
        ) : isFirstPaymentMethod === true && (
            isFirstPaymentMethod = false,
            EventLog.switchedMethod($state.STATE.label || $state.STATE.current)
        );
        performMountOperation && performMountOperation(`${method}[mount]`);

        ({ current: previousCurrency } = CurrencyState.STATE);
      }
    }
  }

  return (state = $state);
}
